export const APPOINTMENT_NOTES_MAX_LENGTH = 10000;

export const getAppointmentNotesFieldProps = ({ locked = false } = {}) => ({
  rows: 8,
  maxLength: APPOINTMENT_NOTES_MAX_LENGTH,
  ...(locked
    ? {
        disabled: true,
        title: "Completed appointment notes are locked",
      }
    : {}),
});

export const getAppointmentNotesDisplayStyle = () => ({
  whiteSpace: "pre-wrap",
  maxHeight: "18rem",
  overflowY: "auto",
});

export const hasAppointmentNotes = (value) => typeof value === "string" && value.trim().length > 0;
